/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React, { type ReactNode } from 'react';

import { useHistory } from 'react-router';

import { ListeTable, ListeTableContainer } from '@mairistem/liste';

import type { Individu } from '@/types';
import { baseUrlApp } from '@/routes';

import RecenseListeTableRow from './RecenseListeTableRow';

interface RecenseListeTableProps {
  items: Array<Partial<Individu>>;
  count: number;
  mode?: string;
  simplified?: boolean;
  perPage: number;
  loading: boolean;
  onLoad: any;
  onSort: any;
  onSelect?: (item: Partial<Individu>) => void;
  typeRecensement?:
    | 'all'
    | 'recenses'
    | 'recenses-regularises'
    | 'non-recenses'
    | 'recenses-recenses-regularises';
  displayRecensement?: boolean;
}

const RecenseListeTable = (props: RecenseListeTableProps) => {
  const {
    items,
    mode,
    simplified,
    count,
    perPage,
    loading,
    onLoad,
    onSort,
    onSelect: onSelectProp,
    typeRecensement,
    displayRecensement,
  } = props;

  const history = useHistory();
  const [selectedItemId, setSelectedItemId] = React.useState<number | null>(
    null,
  );

  const renderRow = (item, invalidate) => (
    <RecenseListeTableRow
      item={item}
      mode={mode}
      simplified={simplified}
      selected={selectedItemId === item?.identifiant}
      invalidate={invalidate}
      displayRecensement={displayRecensement}
    />
  );

  const handleSelect = (selectedItem) => {
    if (simplified && onSelectProp) {
      setSelectedItemId(selectedItem?.identifiant);
      onSelectProp(selectedItem);
    } else if (!simplified) {
      history.push(`${baseUrlApp}recenses/${selectedItem?.identifiant}`);
    }
  };

  return (
    <ListeTableContainer
      // @ts-ignore
      items={items}
    >
      <ListeTable
        items={items}
        loading={loading}
        count={count}
        perPage={perPage}
        onLoad={onLoad}
        onSort={onSort}
        onSelect={handleSelect}
        showCount={!simplified}
        countLabel={(() => {
          switch (typeRecensement) {
            case 'non-recenses':
              return count > 1 ? 'non recensés' : 'non recensé';
            case 'recenses-regularises':
              return count > 1 ? 'recensés régularisés' : 'recensé régularisé';
            case 'all':
              return count > 1
                ? 'recensés et non recensés'
                : 'recensé ou non recensé';
            case 'recenses':
            case 'recenses-recenses-regularises':
            default:
              return count > 1 ? 'recensés' : 'recensé';
          }
        })()}
      >
        {simplified ? (
          <ListeTable.Header>
            <ListeTable.Column name="recense" sortable width={5}>
              Recensé
            </ListeTable.Column>
            <ListeTable.Column name="dateNaissance" sortable width={5}>
              Date de naissance
            </ListeTable.Column>
            <ListeTable.Column name="lieuNaissance" width={6}>
              Lieu de naissance
            </ListeTable.Column>
          </ListeTable.Header>
        ) : (
          <ListeTable.Header>
            <ListeTable.Column name="recense" sortable width={4}>
              Recensé
            </ListeTable.Column>
            <ListeTable.Column
              name="dateRecensement"
              sortable
              width={3}
              only={['m', 'l', 'xl']}
            >
              Recensement
            </ListeTable.Column>
            <ListeTable.Column name="adresse" width={4} only={['l', 'xl']}>
              Adresse
            </ListeTable.Column>
            <ListeTable.Column name="coordonnees" width={3} only={['l', 'xl']}>
              Coordonnées
            </ListeTable.Column>
          </ListeTable.Header>
        )}
        {renderRow as unknown as ReactNode}
      </ListeTable>
    </ListeTableContainer>
  );
};

export default RecenseListeTable;
